import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemActionCategoryIndexComponent } from './crud-index/crud-index.component';
import { SystemActionCategoryCESComponent } from './crud-ces/crud-ces.component';
import { SystemActionCategoryIndexSelectComponent } from './crud-index/crud-index-select.component';
import { SystemActionCategoryCrudIndex } from './crud-index/crud-index';
import { SystemActionCategoriesRoutingModule } from './system-action-categories-routing.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { DialogCloseModule } from 'src/app/shared/components/dialog-close/dialog-close.module';
import { DialogSaveCloseModule } from 'src/app/shared/components/dialog-save-close/dialog-save-close.module';
import { DynamicFormModule } from 'src/app/shared/components/dynamic-form/dynamic-form.module';
import { FieldsModule } from 'src/app/shared/components/fields/fields.module';
import { TableResponsiveModule } from 'src/app/shared/components/table-responsive/table-responsive.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';
import { LayoutCrudIndexModule } from '../shared/layout-crud-index/layout-crud-index.module';



@NgModule({
  declarations: [
    SystemActionCategoryCESComponent,
    SystemActionCategoryCrudIndex,
    SystemActionCategoryIndexComponent,
    SystemActionCategoryIndexSelectComponent,
  ],
  imports: [
    CommonModule,
    SystemActionCategoriesRoutingModule,
    AngularMaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    DynamicFormModule,
    FieldsModule,
    TableResponsiveModule,
    DialogCloseModule,
    DialogSaveCloseModule,
    DialogContainerModule,
    LayoutCrudIndexModule
  ]
})
export class SystemActionCategoriesModule { }
